import { login, getUserInfo, logout, getMenu, getMyk8s, modifyPassword, checkPassword, bindMfa, removeMfa, getCasTicket } from '@/api/user'
import { setToken, getToken, setItem, rmItem } from '@/libs/util'
  export default {
    state: {
      username: '',
      loginuser: '',
      auth: '',
      display: '',
      avatar: '',
      token: getToken(),
      access: ''
    },
    mutations: {
      setAvatar (state, avatar) {
        state.avatar = avatar
      },
      setUserName (state, name) {
        state.userName = name
        state.loginuser = name
      },
      setDisplay (state, display) {
        state.display = display
      },
      setAuth (state, auth) {
        state.auth = auth
      },
      setAccess (state, access) {
        state.access = access
      },
      setToken (state, token) {
        state.token = token
        setToken(token)
      }
    },
    getters: {
      messageUnreadCount: state => state.messageUnreadList.length,
      messageReadedCount: state => state.messageReadedList.length,
      messageTrashCount: state => state.messageTrashList.length
    },
    actions: {
      // 登录
      handleLogin ({ commit }, { username, password }) {
        return new Promise((resolve, reject) => {
          login({
            username,
            password
          }).then(res => {
            const data = res.data
            commit('setUserName', username)
            commit('setToken', data.data.token)
            commit('setAvatar', data.data.avatar)
            commit('setDisplay', data.data.display)
            commit('setAuth', data.data.permissions)
            if (data.data.permissions === 'Admin' || data.data.permissions === 'Approve') {
                commit('setAccess', 0)
            } else {
                commit('setAccess', 1)
            }
            setItem('loginuser', username)
            setItem('jwt', `Bearer ${res.data.data['token']}`)
            setItem('TOKEN', res.data.data['token'])
            setItem('auth', res.data.data['permissions'])
            setItem('display', res.data.data['display'])
            setItem('avatar', res.data.data['avatar'])
            if (res.data.data['permissions'] === 'Admin' || res.data.data['permissions'] === 'Approve') {
              setItem('access', 0)
            } else {
              setItem('access', 1)
            }
            resolve(data)
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 退出登录
      handleLogOut ({ state, commit }) {
        return new Promise((resolve, reject) => {
          logout(state.token).then(() => {
            commit('setToken', '')
            commit('setAccess', [])
            resolve()
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取用户信息
      getUserInfo ({ state, commit }) {
        return new Promise((resolve, reject) => {
          try {
            getUserInfo().then(res => {
              const data = res.data
              resolve(data)
            }).catch(err => {
              reject(err)
            })
          } catch (error) {
            reject(error)
          }
        })
      },
      // 获取用户菜单
      getMenu ({ state, commit }) {
        return new Promise((resolve, reject) => {
          try {
            getMenu().then(res => {
              const data = res.data
              resolve(data)
            }).catch(err => {
              reject(err)
            })
          } catch (error) {
            reject(error)
          }
        })
      },
      // 获取用户k8s集群权限
      getMyk8s ({ state, commit }) {
        return new Promise((resolve, reject) => {
          try {
            getMyk8s().then(res => {
              const data = res.data.data
              let list = []
              let envList = data
              for (var item in envList) {
                  var children = []
                  if (envList[item].length > 0) {
                    for (var i in envList[item]) {
                      if (envList[item][i]['pod_list'] === 1) {
                        children.push(
                          {
                            value: envList[item][i]['name'],
                            label: envList[item][i]['name']
                          }
                        )
                      }
                    }
                  if (children.length > 0) {
                    list.push(
                      {
                          value: item,
                          label: item,
                          children: children
                      }
                    )
                  }
                }
              }
              rmItem('myk8s')
              rmItem('env_list')
              setItem('myk8s', JSON.stringify(list))
              setItem('env_list', JSON.stringify(envList))
              resolve({list: list, envList: envList})
            }).catch(err => {
              reject(err)
            })
          } catch (error) {
            reject(error)
          }
        })
      },
      // 修改密码
      modifyPassword ({ commit }, { name, n, o }) {
        return new Promise((resolve, reject) => {
          modifyPassword({name, n, o}).then(res => {
            const data = res.data
            resolve(data)
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 校验密码
      checkPassword ({ commit }, { name, password }) {
        return new Promise((resolve, reject) => {
          checkPassword({name, password}).then(res => {
            const data = res.data
            resolve(data)
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 绑定MFA
      bindMfa ({ commit }, { code }) {
        return new Promise((resolve, reject) => {
          bindMfa(code).then(res => {
            const data = res.data
            resolve(data)
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 移除MFA
      removeMfa ({ commit }, { code }) {
        return new Promise((resolve, reject) => {
          removeMfa(code).then(res => {
            const data = res.data
            resolve(data)
          }).catch(err => {
            reject(err)
          })
        })
      },
      // 获取CasTicket
      getCasTicket ({ commit }) {
        return new Promise((resolve, reject) => {
          getCasTicket().then(res => {
            const data = res.data
            resolve(data)
          }).catch(err => {
            reject(err)
          })
        })
      }
    }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js